import { FiltersModel } from '../filters';

export interface MoveLineFilterModel extends FiltersModel {
  move_id?: number;
  status?: string;
}
